import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  getFeatureFlagFromParams,
  isFeatureFlagEnabled,
  setFeatureFlagCookie,
} from "@/react/utils/featureFlagCookies";
import type { ButtonVariant } from "@circle-react-uikit/Button";

const COOKIE_NAME = "new_onboarding";

/**
 * Hook to manage the new onboarding flow state through URL parameter and cookie
 * Also returns the correct onboarding button variant (blue/regular)
 */
export const useIsNewOnboardingFlow = (): {
  isNewOnboardingFlow: boolean;
  onboardingButtonVariant: ButtonVariant;
} => {
  const [isNewOnboardingFlow, setIsNewOnboardingFlow] = useState(false);
  const { search } = useLocation();

  useEffect(() => {
    const paramValue = getFeatureFlagFromParams(search, "new_onboarding");

    if (paramValue !== null) {
      setFeatureFlagCookie(COOKIE_NAME, paramValue);
      setIsNewOnboardingFlow(paramValue === "true");
    } else {
      setIsNewOnboardingFlow(isFeatureFlagEnabled(COOKIE_NAME));
    }
  }, [search]);

  const onboardingButtonVariant: ButtonVariant = isNewOnboardingFlow
    ? "marketing-gradient-blue"
    : "marketing-gradient";

  return { isNewOnboardingFlow, onboardingButtonVariant };
};
